const jQueryBridget = require('jquery-bridget');
const InfiniteScroll = require('infinite-scroll');
// make Infinite Scroll a jQuery plugin
jQueryBridget( 'infiniteScroll', InfiniteScroll, $ );

var academy = {

    timer: undefined,

    debounce: function(fn, ms = 300) {
        clearTimeout(this.timer);
        this.timer = setTimeout(fn, ms);
    },

	formSubmitting: false,

	init: function() {
		this.indexItems();
		this.initSearchForm();
        this.initInfiniteScroller();
	},

	getSearchResults: function() {
		return $('.js-academy-search-results');

	},

	initSearchForm: function() {
		var $input = $('.js-academy-search-input'),
			$reset = $('.js-academy-search-reset'),
			$form = $('.js-academy-search-form'),
			$submit = $('.js-academy-search-submit'),
			_this = this;

		if (!$form.length) {
			return false;
		}

		$form.on('submit', function(e) {
			e.preventDefault();

            // SE-1891: Pagination not working for search yet so stop infinite scroll
            _this.destroyPagination();

			if (_this.formSubmitting === true) {
				return false;
			}

			$submit.trigger('changeState', [false]);
			_this.formSubmitting = true;

			$.ajax({
				url: '/perform/education-marketing-academy/search',
				method: 'post',
				dataType: 'html',
				data: {
					query: $input.val()
				},
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
				success: function(response) {
					var $results = _this.getSearchResults();
					//if ($results.mixitup('isMixing')) {
						//$results.mixitup('destroy');
					//}
					$results.replaceWith(response);

                    contentItemsFilter.resetMenu();
                    contentItemsFilter.init();
					_this.indexItems();

					$submit.trigger('changeState', [true]);
					_this.formSubmitting = false;
				},
				error: function(response) {
					// TODO: error handling
					// alert('Oops, something gone wrong. Please, try again.');
					$submit.trigger('changeState', [true]);
					_this.formSubmitting = false;
					// console.log('Not working...')
				}
			});
		});

		$input.on('keyup', function(e) {
            this.value != "" ?  $reset.removeClass('d-none') : $reset.addClass('d-none');
		});

        $input.on('keyup', {'param': 300}, function(e){
            if (this.value !== "") {
                // User typing, add delay before submit
                _this.debounce(() => {
                    $form.submit();
                });
            } else {
                $form.submit();
            }

        });

		$submit.on('changeState', function(e, enabled) {
			if (enabled) {
				return $(this).prop('disabled', false).find('.fa').removeClass('fa-spin fa-refresh').addClass('fa-search');
			}

			$(this).prop('disabled', true).find('.fa').addClass('fa-spin fa-refresh').removeClass('fa-search');
		});

		$reset.on('click', function(e) {
			e.preventDefault();
			$input.val('').trigger('keyup');
		});
	},

	indexItems: function() {
		var $items = $('.js-academy-item'),
			_this = this;

		$items.each(function(i, el) {
			var $el = $(el);

			if ($el.find('a[href="#academyVideoModal"]').length) {
				_this.initVideoModalStuff($el.find('a[href="#academyVideoModal"]'));
			}
		});
	},

	initVideoModalStuff: function($links) {
		$links.each(function(i, el) {
			$(el).on('click', function(e) {
				e.preventDefault();

				var $modal = $($(this).attr('href'));

				$modal.find('iframe').attr('src', $(this).data('video-url'));
				$modal.modal('show');
			})
		});
	},

    destroyPagination: function() {
        $container = $('#contentItemsAcademy');
        $container.infiniteScroll('destroy');
        $('.pagination-links').hide();
        $('.page-load-status').hide();
    },

    initInfiniteScroller: function() {
        $('#contentItemsAcademy').infiniteScroll({
            path: 'ul.pagination > li.active + li a',
            checkLastPage: true,
            hideNav: '.pagination-links',
            status: '.page-load-status',
            history: false
        });

        $container = $('#contentItemsAcademy');

        $container.on( 'load.infiniteScroll', function( event, body ) {
            $items = body.getElementById("contentItemsAcademy").children;
            $container.append($items);
        });
    }
};

academy.init();

